/* eslint-disable import/prefer-default-export */
/**
 * Determines the hasAccess parameter for API calls based on access status filter state
 * Keeping this decoupled as filtering may change drastically in the future
 *
 * @param accessStatusFilter - Array of selected access status filter values
 * @returns boolean | undefined - true for present only, false for absent only, undefined for no filter or both
 */
export const getHasAccessParam = (
  accessStatusFilter: string[]
): boolean | undefined => {
  if (accessStatusFilter.length === 0) {
    return undefined;
  } // No filter selected

  if (accessStatusFilter.length === 2) {
    return undefined;
  } // Both selected = no filter

  if (accessStatusFilter.includes('present')) {
    return true;
  } // Only present selected

  if (accessStatusFilter.includes('absent')) {
    return false;
  } // Only absent selected

  return undefined; // Fallback
};
